  <div class="p-all h-custom-100" *ngIf="!showSchedules">
    <div class="container-fluid border-container p-0 h-100">
      <header>
        <div class="header-left">
          <!--<button class="info-icon"><</button>-->
          <img alt="Logo CCTB" src="assets/img/logo_cctb2.svg" class="logo-cctb-header me-3">
        </div>
        <div class="header-right">
          <span *ngIf="!menu && !production" (click)="decreasePreSelectedDest()" class="px-2">L</span>
          <span *ngIf="!menu && !production" (click)="increasePreSelectedDest()" class="px-4">R</span>
          <span *ngIf="full_stops == 'true'" class="ps-4">F</span>
          <span class="clock" (click)="toggleFullStops()">{{ hour }}</span>
        </div>
      </header>
      <div *ngIf="!menu">
        <div *ngIf="destinationListToShow.length > 0" class="other-line-service">
          <ng-container>
            <div class="next-service-label-container mt-4">
              <div class="next-service-label ml-4 mb-4">
                Destinos
              </div>
              <hr>
            </div>
            <div *ngFor="let destination of destinationListToShow" [ngClass]="destinationName == destination.name ? 'service-itemSel' : 'service-item' ">
              <div class="destination-details" (click)="shearchInSchedule(destination.name)">
                <span class="destination">{{ destination.name }}</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div *ngIf="menu" class="h-custom-120">
        <div class="menu-screen-start">
          <div class="menu-screen-start-text-box">
            Bem vindo ao CCTB
          </div>
          <div class="menu-screen-start-btn-box">
            <button class="menu-screen-start-btn" (click)="iniSearch()">
              Procurar o meu destino!
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="btnsChangeDest" *ngIf="!menu && !showSchedules">
    <ng-container *ngIf="destinationListToShow.length > 0">
      <button class="btnsChangeDestinations" (click)="decreaseDestinationStart()"><i class="bi bi-arrow-left"></i></button>
        <div class="h2 mb-0">{{page+1}}/{{numberOfPages}}</div>
      <button class="btnsChangeDestinations" (click)="increaseDestinationStart()"><i class="bi bi-arrow-right"></i></button>
    </ng-container>
    <ng-container *ngIf="destinationListToShow.length == 0">
      <div class="col-10 text-center align-middle">
        <p class="service-not-exist">A obter lista de destinos!</p>
      </div>
    </ng-container>
  </div>

<!------Schedules Page----->
<div class="p-all" *ngIf="showSchedules">
  <div class="container-fluid border-container p-0" [ngClass]="'bg-white'">
    <header>
      <div class="header-left">
        <div class="bi bi-arrow-left-circle-fill fs-3rem me-3" (click)="goDestinationPage()"></div>
        <img alt="Logo CCTB" src="assets/img/logo_cctb2.svg" class="logo-cctb-header me-3">
      </div>
      <div class="header-right">
        <span class="clock" (click)="timeStopped=31">{{ hour }}</span>
      </div>
    </header>
      <div *ngIf="firstLines.lenght <= 0" class="row justify-content-center">
        <div class="col-10 text-center align-middle py-5">
          <img src="assets/img/out_service.png" alt="Fora de Serviço" class="img-out-service">
          <p class="service-error">Fora de serviço.</p>
        </div>
      </div>
      <div class="row justify-content-center">
        <div *ngIf="errorSchedule" class="col-10 text-center align-middle py-5">
          <img src="assets/img/not_exist_service.png" alt="Serviço inexistente" class="img-out-service">
          <p class="service-not-exist">Serviço inexistente!</p>
        </div>
        <div *ngIf="noSchedule" class="col-10 text-center align-middle py-5">
          <img src="assets/img/not_exist_service.png" alt="Serviço inexistente" class="img-out-service">
          <p class="service-not-exist">Sem serviços para o destino selecionado!</p>
        </div>
      </div>
      <div *ngIf="firstLines.length > 0" class="first-line-service">
        <div class="next-service-list" [ngClass]="'bg-next-service'">
          <div class="next-service-label-container">
            <div class="next-service-label">
              Próximo serviço
            </div>
            <hr [ngClass]="'line'">
          </div>
          <div *ngFor="let line of firstLines" class="next-service-item">
            <div class="service-details">
              <span class="sub-details-operator">{{ line.operator }}</span>
              <span class="destination">{{ line.destination }}</span>
              <!--<marquee *ngIf="line.observation.length>20" class="sub-details">{{line.observation}}</marquee>-->
              <span class="sub-details">{{ line.observation }}</span>
            </div>
            <div class="d-flex flex-column">
              <div class="service-time">{{ line.time }}</div>
              <span class="sub-details-cais text-center">Cais {{ line.platform }}</span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="lineList.length > 0" class="other-line-service">
        <ng-container>
          <div class="next-service-label-container mt-4">
            <div class="next-service-label">
              Serviços seguintes
            </div>
            <hr [ngClass]="'line'">
          </div>
          <div *ngFor="let line of lineList" [ngClass]="'service-item'">
            <div class="service-details">
              <span class="sub-details-operator">{{ line.operator }}</span>
              <span class="destination">{{ line.destination }}</span>
              <!--<marquee *ngIf="line.observation.length>20" class="sub-details">{{line.observation}}</marquee>-->
              <span class="sub-details">{{ line.observation }}</span>
            </div>
            <div class="d-flex flex-column">
              <span class="service-time">{{ line.time }}</span>
              <span class="sub-details-cais text-center">Cais {{ line.platform }}</span>
            </div>
          </div>
        </ng-container>
      </div>
  </div>
</div>
<footer>
  <div><img alt="Logo Wegoshare" src="../assets/img/logo_wgs_white.png" class="img-fluid logo-wgs"></div>
  <div><span *ngIf="!conection" class="bi bi-wifi-off fs-3rem me-3"></span><i class="bi bi-info-circle fs-3rem" data-bs-toggle="modal" data-bs-target="#myModal" (click)="showModal()"></i></div>
</footer>

<!-- The Modal -->
<div class="modal" id="myModal">
  <div class="modal-dialog modal-dialog-centered ">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-11 d-inline-flex">
              <img alt="Logo CCTB" src="assets/img/logo_cctb.png" class="img-fluid logo-cctb">
              <h4 class="modal-title ms-2">CCTB - Centro Coordenador de Transportes de Braga</h4>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="p-3">
          <h3 class="modal-title">Sistema de Informação ao público para pessoas com deficiência visual</h3>
        </div>
        <div class="p-3 fs-1-25rem">
          A acessibilidade em sistemas de transporte público é fundamental para garantir a
          inclusão social e a mobilidade autónoma de pessoas com deficiências visuais ou

          dificuldades de visão. Tecnologias assistivas, como displays de elevado contraste, e-
          paper, beacons sonoros e pontos de informação com TTS (text-to-speech),

          desempenham um papel essencial ao reduzir barreiras e tornar as informações
          acessíveis a todos os utilizadores, independentemente das suas capacidades.
        </div>
        <div class="modal-image mt-4">
          <div class="row"></div>
          <img alt="Logo Wegoshare" src="assets/img/logo_wgs_black.png" class="logo-wgs-footer img-fluid">
        </div>
        <div class="modal-image mt-4">
          <span class="footer-text">Wegoshare, Lda. &copy; {{ year }}</span>
        </div>
        <div class="modal-image mt-4">
          <span class="footer-text">versão {{ version }}</span>
        </div>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer p-0">
        <button #closeModal type="button" class="btn btn-danger btn-80" data-bs-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>

